/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'password': {
    width: 16,
    height: 16,
    viewBox: '0 0 40.46 40.9',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M8.94 14.58A4.37 4.37 0 1 0 13 8.65a4.29 4.29 0 0 0-3.06 1.27l-5.8-5.73A12.52 12.52 0 0 1 24.79 17.3L39.3 31.9l.62 8.47-8.55-.58-1.64-1.84v-2.38a.72.72 0 0 0-.22-.52l-1.21-1.19a.72.72 0 0 0-.51-.21h-2.46l-2-2v-2.44a.72.72 0 0 0-.21-.5L22 27.56a.72.72 0 0 0-.52-.22H19l-2.52-2.27h-.05A12.53 12.53 0 0 1 .87 10" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/password.js